import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import Address from "../../../commonComponents/Address";
import { AddressType } from "../../../../static/types/commonTypes/addressType";
import { DateType } from "../../../../static/types/commonTypes/dateType";
import DateComponent from "../../../commonComponents/DateComponent";

const IntraResortSeatTransfer = () => {

    const {
        
        seatTransfertChange,
        setSeatTransfertChange,

        address,
        setAddress,
        setAddressValidity,
        addressChecked,
        
        seatTransfertChangeEffectiveDate,
        setseatTransfertChangeEffectiveDate,
        setseatTransfertChangeEffectiveDateValidity,
        seatTransfertChangeEffectiveDateChecked,

    } = useAppContext() as AppContextType

    const updateAddress = ( partialAddress: Partial<AddressType> ) => setAddress({ ...address, ... partialAddress })
    const updateDate = (data: Partial<DateType>) => setseatTransfertChangeEffectiveDate ({...seatTransfertChangeEffectiveDate, ...data});

    return (
        <div>
            <div className = 'col-sm-10 d-flex align-items-center mt-1'>
                <label htmlFor = "denomination" className = "col-sm-2 col-form-label mb-0">
                    Modification
                </label>
                <select
                    className = 'form-select w-75'
                    id = "denomination"
                    onChange = {( e ) => setSeatTransfertChange( Number( e.target.value ))}
                    value = { seatTransfertChange }
                >
                    <option value = { 0 }>Aucune modification</option>
                    <option value = { 1 }>Avec un transfert de siège</option>
                </select>
            </div>

            {
                seatTransfertChange === 1 &&
                <div className = "mt-3">
                    <h6 className = 'text-bold' style={{backgroundColor: 'red', padding: '5px', color: 'white', fontSize: '13px'}}>
                        IMPORTANT : Cette partie ne prend en compte que les transferts de siège intra-ressort. Pour tout autres changement de siège veuillez utiliser un des formulaires proposés en étape 1 (« Transfert de siège dans le département » ou « Transfert de siège hors département »).
                    </h6>
                        <div>
                            <h6 className = 'text-bold'>
                                Nouvelle adresse du siège social
                            </h6>
                            <div className = "tab-content" style={{borderRadius: '5px'}}>
                                <Address
                                    address = { address }
                                    draftFieldName = 'address'
                                    changeAddress = { updateAddress }
                                    checked = { addressChecked }
                                    onValidationChange = {( isValid: boolean ) => setAddressValidity( isValid )}
                                />
                            </div>
                        </div>

                        <div className = "mt-3">
                            <h6 className = 'text-bold'>
                                Date d'effet
                            </h6>
                            <span>
                                Date à laquelle la nouvelle adresse est effective. Cette date peut être différente de la date de prise de décision (date de l'acte, en haut du formulaire).
                            </span>
                            <div className = "mt-2 col-sm-7">
                                <DateComponent
                                    id="dateSeatTransfert"
                                    date = { seatTransfertChangeEffectiveDate }
                                    draftFieldName = "seatTransfertChangeEffectiveDate"
                                    changeDate = { updateDate }
                                    dateLabel = "Date d'effet"
                                    checked = { seatTransfertChangeEffectiveDateChecked }
                                    onValidationChange = {( isValid: boolean ) => setseatTransfertChangeEffectiveDateValidity( isValid )}
                                    required = { false }
                                />
                            </div>
                            
                        </div>
                </div>
            }
        </div>
    )
}

export default IntraResortSeatTransfer;